import { GET_ERRORS } from './types';

export const clearErrors = () => ({ type: GET_ERRORS, payload: {} })